import { clear } from '@/plugin/popup'

export default function(router) {
  router.beforeEach((to, from, next) => {
    // beforeEach是router的钩子函数，在进入路由前执行
    const pop = document.querySelectorAll('.su-mask')
    for (let i = 0; i < pop.length; i++) {
      if (pop[i]) {
        pop[i].style.display = 'none'
      }
    }
    clear()
    next() // 执行进入路由，如果不写就不会进入目标页
  })
}
